import React from 'react'

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options?: Array<{ label: string; value: string }>
  selectedOption?: { label: string; value: string }
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
  placeholder?: string
}

export const Select: React.FC<SelectProps> = ({ options, selectedOption, placeholder, ...props }) => {
  return (
    <select
      {...props}
      value={selectedOption?.value || props.value}
      style={{
        width: '100%',
        padding: '8px 12px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        fontSize: '14px',
        backgroundColor: 'white',
        ...props.style,
      }}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options?.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
      {props.children}
    </select>
  )
}
